import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { AccessibilityNewTwoTone } from "@mui/icons-material";


export const ConfirmationModalTransportator = (props: any) => {
  const newText = props.message.split("\n").map((str: any) => <div>{str}</div>);
  const onClickCloseDialog = () => props.onClose();
  const updateAction = () => {
    props.updateAction();
    onClickCloseDialog();
  };
 
  return (
    <>
      <Dialog
        open={props.setOpen}
        PaperProps={{
          sx: { minWidth: "790px !important", borderRadius: "4px" },
        }}
      >
        <DialogTitle>
          <Grid
            container
            spacing={2}
            alignItems="center"
            alignContent="center"
            direction="row"
          >
            <Grid xs="auto" item>
             {props.checkIsDelete == undefined || props.checkIsDelete == 'delete' ? <InfoIcon fontSize="small" sx={{ color: "#c8017d" }}/> : <ReportProblemIcon fontSize="small" color="error"/>}
            </Grid>
            <Grid xs="auto" item>
              {" "}
             <span>{props.title}</span> 
            </Grid>
            <Grid
              xs
              item
              sx={{
                justifyContent: "flex-end",
                display: "flex",
              }}
            >
              <CloseIcon
                color="disabled"
                fontSize="small"
                onClick={onClickCloseDialog}
              />
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent>
          <DialogContentText>
          <Typography variant="bodySmall">{newText}</Typography> 
            <p></p>
            <Typography variant="bodySmall">{props.messageNote}</Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Stack direction="row" spacing={2} p={1} mr={1}>
            <Button
              sx={{
                maxWidth: "111px",
                maxHeight: "48px",
                minWidth: "111px",
                minHeight: "48px",
              }}
              variant={props.checkIsDelete == undefined ||props.checkIsDelete == 'delete'? "outlined" :"contained"}
              onClick={onClickCloseDialog}
            >
              <Typography 
                sx={{
                  textTransform: "capitalize",
                  fontWeight: 700,
                  lineHeight: 2.25,
                  color:`${props.checkIsDelete == undefined ||props.checkIsDelete == 'delete' ? "#C8017D" : '#ffffff'}`
                }}
                variant="subtitle1"
              >
                {props.cancel}
              </Typography>
            </Button>

          {props.checkIsDelete == undefined ||props.checkIsDelete == 'delete' ? <Button
              sx={{ maxHeight: "48px", minWidth: "111px", minHeight: "48px" }}
              variant="contained"
              color="accent"
              onClick={updateAction}
            >
              <Typography
                sx={{
                  textTransform: "capitalize",
                  fontWeight: 700,
                  lineHeight: 2.25,
                  color: 'white'
                }}
                variant="subtitle1"
              >
                {props.confirm}
              </Typography>
            </Button> :""}
          </Stack>
        </DialogActions>
      </Dialog>
    </>
  );
};
